module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pdp-tab-expandable-content":{"more-button":"Mehr anzeigen"}}}')
  delete Component.options._Ctor
}
